import { Button } from 'components/atoms/Button';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIconOutline } from 'utils/icons';

type ExpertAuthBackButtonProps = {
  onClick: () => void;
  className?: string;
};

const ExpertAuthBackButton: FC<ExpertAuthBackButtonProps> = ({
  onClick,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      structure="text"
      className={
        className ??
        'h-10 !p-2 rounded-lg flex !items-center space-x-2 group hover:bg-primary-50 w-fit'
      }
      onClick={onClick}
    >
      <ArrowLeftIconOutline className="h-4 text-primary-600 group-hover:text-primary-800" />
      <span className="text-primary-600 font-medium text-sm group-hover:text-primary-800">
        {t('back')}
      </span>
    </Button>
  );
};

export default ExpertAuthBackButton;
